<script lang="ts" setup>
const {
  public: { siteUrl, webAppLink },
} = useRuntimeConfig()

const { t } = useI18n()

useSeoMeta({
  title: t('token-page-title'),
  description: t('token-hero-description'),
  ogTitle: t('token-page-title'),
  ogDescription: t('token-hero-description'),
  ogImage: `${siteUrl}/images/token/preview.png`,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogType: 'website',
  twitterTitle: t('token-page-title'),
  twitterDescription: t('token-hero-description'),
  twitterImage: `${siteUrl}/images/token/preview.png`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  layout: 'menu',
})

const roundsAndPricing = [
  {
    id: 0,
    round: t('public'),
    allocation: '30,000,000',
    percentOfSupply: '4.00%',
    price: '$0.018',
    amount: '$540,000',
    fdv: '$13,500,000',
  },
  {
    id: 1,
    round: t('pre-seed'),
    allocation: '30,000,000',
    percentOfSupply: '4.00%',
    price: '$0.008',
    amount: '$240,000',
    fdv: '$6,000,000',
  },
  {
    id: 2,
    round: t('seed'),
    allocation: '37,500,000',
    percentOfSupply: '5.00%',
    price: '$0.013',
    amount: '$487,500',
    fdv: '$9,750,000',
  },
  {
    id: 3,
    round: t('private'),
    allocation: '20,000,000',
    percentOfSupply: '2.667%',
    price: '$0.015',
    amount: '$300,000',
    fdv: '$11,250,000',
  },
  {
    id: 4,
    round: t('kol'),
    allocation: '15,000,000',
    percentOfSupply: '2.00%',
    price: '$0.015',
    amount: '$225,000',
    fdv: '$11,250,000',
  },
  {
    id: 5,
    round: t('team'),
    allocation: '75,000,000',
    percentOfSupply: '10.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 6,
    round: t('advisors'),
    allocation: '37,500,000',
    percentOfSupply: '5.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 7,
    round: t('cex-allocation-excl-tier-1-exchange'),
    allocation: '15,000,000',
    percentOfSupply: '2.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 8,
    round: t('tier-1-exchange'),
    allocation: '55,950,000',
    percentOfSupply: '7.46%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 9,
    round: t('liquidity'),
    allocation: '29,050,000',
    percentOfSupply: '3.873%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 10,
    round: t('marketing'),
    allocation: '105,000,000',
    percentOfSupply: '14.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 11,
    round: t('reserve-fund'),
    allocation: '112,500,000',
    percentOfSupply: '15.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 12,
    round: t('community-rewards'),
    allocation: '120,000,000',
    percentOfSupply: '16.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
  {
    id: 13,
    round: t('airdrop-campaign'),
    allocation: '67,500,000',
    percentOfSupply: '9.00%',
    price: '-',
    amount: '-',
    fdv: '-',
  },
]

const vestingUnlocks = {
  tgeUnlocked: t(
    'public-6m-cex-excl-tier-1-4-5m-tier-1-45m-liquidity-29-05m-marketing-2-916m-community-rewards-6m'
  ),
  community: [
    t('public-20-at-tge-then-6-month-linear-unlocks-4m-month'),
    t(
      'airdrop-varies-by-airdrop-type-quests-referrals-venues-but-capped-by-trs'
    ),
    t('community-rewards-5-at-tge-then-48-months-linear'),
  ],
  investors: [
    t('pre-seed-4-month-cliff-then-21-months-linear'),
    t('seed-3-month-cliff-then-15-months-linear'),
    t('private-3-month-cliff-then-12-months-linear'),
    t('kol-3-month-cliff-then-7-months-linear'),
  ],
  teamOps: [
    t('team-13-month-cliff-then-24-months-linear'),
    t('advisors-6-month-cliff-then-24-months-linear'),
    t('cex-excl-tier-1-30-at-tge-then-24-months-linear'),
    t('tier-1-exchange-80-43-at-tge-45m-remaining-19-57-from-t-4m'),
    t('liquidity-100-at-tge'),
    t('marketing-2-78-at-tge-2-916m-then-36-months-linear'),
    t('reserve-fund-13-month-cliff-then-36-months-linear'),
  ],
}

const linksAndSocials = [
  { icon: '🌐', text: t('website'), url: 'https://belong.net/' },
  {
    icon: '🚀',
    text: t('belong-checkin-info'),
    url: 'https://belong.net/engagement',
  },
  {
    icon: '📄',
    text: t('deck-and-tokenomics'),
    url: 'https://docsend.com/view/mni2jzh2d25tbm2m',
  },
  {
    icon: '📘',
    text: t('whitepaper'),
    url: 'https://docs.belong.net/belong-checkin/whitepaper',
  },
  { icon: '📢', text: t('x-twitter'), url: 'https://x.com/belongnet' },
  { icon: '💬', text: t('telegram-channel'), url: 'https://t.me/belongnet' },
  { icon: '👥', text: t('community-chat'), url: 'https://t.me/belongchat' },
  { icon: '👨‍💻', text: t('api-documentation'), url: 'https://docs.belong.net/' },
  {
    icon: '🧩',
    text: t('whitelabel'),
    url: 'https://docsend.com/view/km5va4t45tcxv84x',
  },
  { icon: '🖥️', text: t('web-app'), url: webAppLink },
  {
    icon: '📱',
    text: t('ios-app'),
    url: 'https://apps.apple.com/us/app/belong-nft-tickets-events/id1609712143',
  },
  {
    icon: '🤖',
    text: t('android-app'),
    url: 'https://play.google.com/store/apps/details?id=network.belong.app&hl=en',
  },
]
</script>

<template>
  <div class="max-w-268 mx-auto px-5 xl:px-0 py-10 pt-30">
    <!-- HERO -->
    <section
      class="bg-[#FFFFFF05] border border-[#FFFFFF21] rounded-[1.25rem] p-6 md:p-7 mb-7"
    >
      <div class="flex flex-wrap items-center gap-2 mb-3">
        <span
          class="inline-flex items-center px-3 py-1 border border-[#FFFFFF21] rounded-full text-white/60 text-xs"
          >{{ t('ticker-long') }}</span
        >
        <span
          class="inline-flex items-center px-3 py-1 border border-[#FFFFFF21] rounded-full text-white/60 text-xs"
          >{{ t('supply-750-000-000') }}</span
        >
        <span
          class="inline-flex items-center px-3 py-1 border border-[#FFFFFF21] rounded-full text-white/60 text-xs"
          >{{ t('public-sale-oct-22-2025') }}</span
        >
        <span
          class="inline-flex items-center px-3 py-1 border border-[#FFFFFF21] rounded-full text-white/60 text-xs"
          >{{ t('tge-oct-29-2025') }}</span
        >
        <span
          class="inline-flex items-center px-3 py-1 border border-[#FFFFFF21] rounded-full text-white/60 text-xs"
          >{{ t('initial-circ-tge-70-966-666') }}</span
        >
      </div>
      <p class="text-2xl md:text-[2rem] tracking-wide">
        {{ t('token-hero-title') }}
      </p>
      <p class="text-white/60 md:text-base mt-2">
        {{ t('token-hero-description') }}
      </p>
    </section>

    <!-- PULSE AIRDROP -->
    <section class="mb-7">
      <div
        class="bg-[#FFFFFF05] border border-[#FFFFFF21] rounded-[1.25rem] p-6"
      >
        <h2 class="text-2xl tracking-wide mb-3">
          {{ t('token-pulse-airdrop-title') }}
        </h2>
        <p class="mb-3 text-white/80">
          {{ t('token-pulse-airdrop-description') }}
        </p>
        <a
          href="https://www.alphabot.app/pulse/belong"
          target="_blank"
          rel="noopener"
          class="inline-flex items-center justify-center gap-3.5 border border-[#7540EE] hover:bg-[#7540EE] rounded-full py-2.5 px-6"
        >
          {{ t('token-pulse-airdrop-button') }}
        </a>
      </div>
    </section>

    <!-- ROUNDS & PRICING -->
    <section class="mb-7">
      <div
        class="bg-[#FFFFFF05] border border-[#FFFFFF21] rounded-[1.25rem] p-6"
      >
        <h2 class="text-2xl tracking-wide mb-4">
          {{ t('token-rounds-pricing-title') }}
        </h2>
        <div class="overflow-auto rounded-xl border border-[#FFFFFF21]">
          <table class="w-full min-w-[900px]">
            <thead>
              <tr class="border-b border-[#FFFFFF21]">
                <th
                  class="text-left bg-[#0e1622] text-white/70 font-semibold p-3"
                >
                  {{ t('round') }}
                </th>
                <th
                  class="text-left bg-[#0e1622] text-white/70 font-semibold p-3"
                >
                  {{ t('allocation-tokens') }}
                </th>
                <th
                  class="text-left bg-[#0e1622] text-white/70 font-semibold p-3"
                >
                  {{ t('of-supply') }}
                </th>
                <th
                  class="text-left bg-[#0e1622] text-white/70 font-semibold p-3"
                >
                  {{ t('price-usd') }}
                </th>
                <th
                  class="text-left bg-[#0e1622] text-white/70 font-semibold p-3"
                >
                  {{ t('amount-usd') }}
                </th>
                <th
                  class="text-left bg-[#0e1622] text-white/70 font-semibold p-3"
                >
                  {{ t('fdv-at-round') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in roundsAndPricing"
                :key="item.id"
                class="border-b border-dashed border-[#FFFFFF21] hover:bg-white/5"
              >
                <td class="p-3">
                  {{ item.round }}
                </td>
                <td class="p-3">
                  {{ item.allocation }}
                </td>
                <td class="p-3">
                  {{ item.percentOfSupply }}
                </td>
                <td class="p-3">
                  {{ item.price }}
                </td>
                <td class="p-3">
                  {{ item.amount }}
                </td>
                <td class="p-3">
                  {{ item.fdv }}
                </td>
              </tr>
              <tr class="border-b border-dashed border-[#FFFFFF21]">
                <td colspan="6" class="p-3 text-white/60">
                  {{ t('total-750-000-000-long-100') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- VESTING & UNLOCKS -->
    <section class="mb-7">
      <div
        class="bg-[#FFFFFF05] border border-[#FFFFFF21] rounded-[1.25rem] p-6"
      >
        <h2 class="text-2xl tracking-wide mb-4">
          {{ t('token-vesting-unlocks-title') }}
        </h2>
        <div
          class="mb-4 border-l-4 border-[#67e8f9] bg-[#67e8f910] p-3 rounded"
        >
          <strong>{{ t('tge-t-0m-unlocked') }}</strong>
          {{ vestingUnlocks.tgeUnlocked }}
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h3 class="text-lg font-semibold mb-2 text-[#E0BDFF]">& Public</h3>
            <ul class="space-y-2">
              <li v-for="item in vestingUnlocks.community" :key="item">
                <strong>{{ item.split(':')[0] }}:</strong>
                {{ item.split(':')[1] }}
              </li>
            </ul>
          </div>
          <div>
            <h3 class="text-lg font-semibold mb-2 text-[#E0BDFF]">
              {{ t('investors') }}
            </h3>
            <ul class="space-y-2">
              <li v-for="item in vestingUnlocks.investors" :key="item">
                <strong>{{ item.split(':')[0] }}:</strong>
                {{ item.split(':')[1] }}
              </li>
            </ul>
          </div>
          <div>
            <h3 class="text-lg font-semibold mb-2 text-[#E0BDFF]">& Ops</h3>
            <ul class="space-y-2">
              <li v-for="item in vestingUnlocks.teamOps" :key="item">
                <strong>{{ item.split(':')[0] }}:</strong>
                {{ item.split(':')[1] }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- LINKS & SOCIALS -->
    <section class="mb-7">
      <div
        class="bg-[#FFFFFF05] border border-[#FFFFFF21] rounded-[1.25rem] p-6"
      >
        <h2 class="text-2xl tracking-wide mb-4">
          {{ t('token-links-socials-title') }}
        </h2>
        <ul class="space-y-2">
          <li v-for="link in linksAndSocials" :key="link.url">
            {{ link.icon }}
            <a
              :href="link.url"
              target="_blank"
              rel="noopener"
              class="text-[#67e8f9] hover:underline"
            >
              {{ link.text }}
            </a>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
